<template>
  <div class="company-overview">
    <Banner  :bannerUrl="bannerUrl" />
    <div class="container">
      <div class="company-intro">
        <h2>{{ $t('companyPage.groupIntro') }}</h2>
        <p v-html="$t('companyPage.introText')"></p>
      </div>
      <div class="company-service fb">
        <div class="left" :class="{ en: locale === 'en' }">
          <img :src="leftImg">
          <span class="text1">{{ $t('companyPage.feature1') }}</span>
          <span class="text2">{{ $t('companyPage.feature2') }}</span>
          <span class="text3">{{ $t('companyPage.feature3') }}</span>
        </div>
        <div class="right">
          <div class="fs">
            <img :src="rightImg">
          </div>
          <div class="title">{{ $t('companyPage.rightTitle') }}</div>
          <div class="desc">{{ $t('companyPage.rightText') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="Company">
import Banner from '@/components/banner'
import { useI18n } from "vue-i18n";
const { locale } = useI18n({useScope: "global"})
const bannerUrl = require('@assets/images/banner/banner-company-overview.png');
const leftImg = require('@assets/icons/ico_overview_left.svg');
const rightImg = require('@assets/icons/ico_overview_right.svg');
</script>

<style lang="less" scoped>
.company-overview {
  .company-intro {
    padding: 80px 0;
    h2 {
      font-weight: 600;
      font-size: 32px;
      color: #151E2C;
      margin-bottom: 20px;
    }
    p {
      color: #5A677C;
      font-size: 16px;
      line-height: 36px;
    }
  }
  .company-service {
    background-color: #FCFCFC;
    margin-bottom: 80px;
    .left {
      position: relative;
      margin: 95px 0 0 89px;
      &.en {
        .text2 {
          font-size: 18px;
          left: 50px;
        }
        .text3 {
          font-size: 18px;
          right: 44px;
        }
      }
      span {
        position: absolute;
        color: #00AFAF;
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        &.text1 {
          color: #FFF;
          line-height: 46px;
          top: 38px;
          left: 50%;
          transform: translate(-50%, 0);
        }
        &.text2 {
          top: 285px;
          left: 67px;
        }
        &.text3 {
          top: 285px;
          right: 67px;
        }
      }
      img {
        width: 400px;
      }
    }
    .right {
      width: 381px;
      height: 335px;
      padding: 59px 50px;
      background: #F8F8F8;
      margin-right: 99px;

      img {
        width: 70px;
        height: 72.09px;
      }

      .title {
        color: #151E2C;
        font-size: 20px;
        font-weight: 500;
        line-height: 42px;
        margin-top: 25.9px;
        margin-bottom: 10px;
      }

      .desc {
        color: rgba(21, 30, 44, 0.50);
        font-size: 16px;
        line-height: 28px; /* 175% */
      }
    }
    
  }
}
</style>